<ion-grid>
    <ion-row class="ion-justify-content-center">
        <ion-col size="12" size-xs="12" size-sm="12" size-md="10" size-lg="8" size-xl="8">
            <ion-card class="applicationsCard">
                <ion-card-header>
                    <ion-card-subtitle> Applications </ion-card-subtitle>
                </ion-card-header>
                <ion-list lines="none" class="my-applications-list" *ngIf="myApplicationsReady == true">
                    <ion-item [button]="false" *ngFor="let app of myApplications">
                        <div class="wrapper-div">
                            <ion-label class="c-1">
                                <div class="app-item-title">{{ app?.name }}</div>
                                <p class="app-item-property">{{ app?.city }}, {{ app?.state }}</p>
                                <p class="app-item-property">
                                    {{ app?.type }}
                                </p>
                            </ion-label>

                            <div class="c-2">
                                <ion-text>
                                    <p class="title-lbl">Dates:</p>
                                    <p class="app-item-property lbl-dates">
                                        {{ app?.startdate | date : 'longDate' : 'UTC' }} - <br />
                                        {{ app?.enddate | date : 'longDate' : 'UTC' }}
                                    </p>
                                </ion-text>
                            </div>

                            <ion-text class="c-3">
                                <p class="title-lbl">Application Status:</p>
                                <p class="app-item-property lbl-pill">
                                    {{ app?.states }}
                                </p>
                            </ion-text>

                            <div class="c-4">
                                <!-- <ion-text 
                                [routerLink]="[
                                    '/documents/application/additionaldocuments',
                                    app.id
                                ]"
                                [routerDirection]="'forward'"
                            > -->
                                <ion-text [routerLink]="['/application/', app.id]" [routerDirection]="'forward'">
                                    <!-- application -->
                                    View & Upload Documents
                                    <ion-icon name="chevron-forward-outline"></ion-icon>
                                </ion-text>
                            </div>
                        </div>
                    </ion-item>
                </ion-list>

                <ion-list *ngIf="myApplicationsReady == false">
                    <ion-item>
                        <ion-label>
                            <h3>
                                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                            </h3>
                            <p>
                                <ion-skeleton-text animated style="width: 90%"></ion-skeleton-text>
                            </p>
                            <p>
                                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                            </p>
                        </ion-label>
                    </ion-item>
                    <ion-item>
                        <ion-label>
                            <h3>
                                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                            </h3>
                            <p>
                                <ion-skeleton-text animated style="width: 90%"></ion-skeleton-text>
                            </p>
                            <p>
                                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                            </p>
                        </ion-label>
                    </ion-item>
                    <ion-item>
                        <ion-skeleton-text animated style="width: 27px; height: 27px" slot="start"></ion-skeleton-text>
                        <ion-label>
                            <h3>
                                <ion-skeleton-text animated style="width: 55%"></ion-skeleton-text>
                            </h3>
                            <p>
                                <ion-skeleton-text animated style="width: 85%"></ion-skeleton-text>
                            </p>
                            <p>
                                <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
                            </p>
                        </ion-label>
                    </ion-item>
                </ion-list>
            </ion-card>
        </ion-col>
    </ion-row>
</ion-grid>
